<template>
    <div class="project">
        <nav class="nav-container">
            <headers></headers>
            <div class="nav-tabs">
                <div class="Logo-container">
                    <div class="Logo">
                        <div>
                            <img style="width: 40px;" :src="navItems[0].link" alt="">
                        </div>
                        <div>
                            {{ navItems[0].name }}
                        </div>
                    </div>
                </div>
                <div class="nav-items-group">
                    <div @mouseover="dropDownChange(item)" v-for="item in navItems" :key="item.name"
                        v-show="item.name !== '遵农共享'">
                        <div @click="Active(item)" class="nav-item" :class="{ 'active': activeNav === item.name }"
                            v-if="item.name === 'sustainableDevelopment' || item.name === 'home'">
                            {{ $t(`navItems.${item.name}`) }}
                        </div>
                        <el-dropdown @command="handleCommand" v-else trigger="hover" class="nav-item"
                            :class="{ 'active': activeNav === item.name }">
                            <div>
                                {{ $t(`navItems.${item.name}`) }}
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="subItem" class="dropdown-item" v-for="subItem in downList"
                                    :key="subItem.label">{{ $t(`downlist.${subItem.label}`)
                                    }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </nav>
        <div>
            <div style=" width: 100%;position: relative;">
                <img style="width: 100%;height: 30em;object-fit: cover;display: block;" :src="bg" alt="">
                <div>
                    <div
                        style="position: absolute;min-width: 1500px;top: 50%;left: 50%;transform: translate(-50%,-50%);z-index: 1;">
                        <div style="color: #fff;font-size: 3em;">
                            {{ $t('development.title') }}
                        </div>
                        <div style="color: #A8B99B;font-size: 1.25em;margin-bottom: 3em;">
                            {{ $t('development.content1') }}
                        </div>
                        <div style="color: #fff;font-size: 1em; border-top: 1px solid #fff;width: 70%;padding: 1em 0;">
                            {{ $t('development.content2') }}
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; background-color: #F6F6F6;">
                <div style="display: flex;margin: 0 auto;justify-content: space-between;gap: 2em;">
                    <div
                        style="width: 50%;height: 100%;padding: 3em;display: flex;justify-content: center;align-items: center;">
                        <img style="width: 60%;height: 30em;object-fit: cover;" :src="banner" alt="">
                    </div>
                    <div style="width: 50%;height: 100%;background-color: #fff;padding: 3em;">
                        <div>
                            <div style="font-size: 2.5em;color:#46B135;">
                                {{ $t('development.title1') }}
                            </div>
                            <div style="font-size: 1.25em;">
                                {{ $t('development.content3') }}
                            </div>
                            <div>
                                <div ref="itemRef" @mouseover="itemActive(index)" @mouseout="itemout(index)"
                                    style="transition: all 0.3s ease-in-out; border: 1px solid #CCCCCC;margin: 1em 0;"
                                    v-for="(item, index) in list" :key="item.content">
                                    <div style="font-weight: bold;font-size: 1.25em;padding: 1em;">
                                        {{ $t(`development.${item.title}`) }}

                                    </div>
                                    <div style="padding: 1em;">
                                        <div style="line-height: 2em;">
                                            {{ $t(`development.${item.content}`) }}
                                        </div>
                                        <div v-if="item.text3" style="line-height: 2em;">
                                            {{ $t(`development.${item.text3}`) }}
                                        </div>
                                    </div>
                                    <div style="transition: all 0.3s ease-in-out;" ref="lineRef" :style="style(index)">
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div style="position: relative;">
                <img style="width: 100%;height: 45em;object-fit: cover;" :src="VCG" alt="">
                <div
                    style="position: absolute;top: 50%;transform: translateY(-50%);display: grid;grid-template-columns: repeat(3, 1fr);text-align: center;justify-items: center;">
                    <div style="width: 45%;color: white;position: relative;" v-for="(item, index) in content"
                        :key="item.title">
                        <div style="font-size: 1.75em;font-weight: bold;margin-bottom: 1em;">
                            {{ $t(`development.${item.title}`) }}
                        </div>
                        <div style="font-size: 1em;">
                            {{ $t(`development.${item.content}`) }}
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div style="font-size: 2.5em;color:#46B135;text-align: center;margin: 3em 0;">
                    {{ $t('development.title3') }}
                </div>
                <div style="display: flex;justify-content: space-between;gap: 2em;width: 1500px;margin: 0 auto;">
                    <div style="width: 50%;height: 100%;">
                        <img style="width: 100%;height: 45em;" :src="top" alt="">
                    </div>
                    <div style="width: 50%;height: 100%;background-color: #fff;padding: 3em;">

                        <div v-for="(item, index) in list2" :key="item.content">
                            <div style="font-weight: bold;font-size: 1.25em;padding: 1em;">
                                {{ $t(`development.${item.title}`) }}
                            </div>
                            <div style="line-height: 2em;">
                                {{ $t(`development.${item.content}`) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="case-section-container">
        <div class="case-section-title">
            {{ $t('development.subtitle11') }}
        </div>
        <div class="case-item">
            <div class="case-image-wrapper">
                <img style="width: 100%;height: 30em;object-fit: cover;border-radius: 8px;" :src="xinghuajie" alt=""></img>
            </div>
            <div class="case-content-wrapper">
                <div class="case-name">
                    {{ $t('development.name') }}
                </div>
                <div class="case-desc">
                    {{ $t('development.text11') }}
                </div>
            </div>
        </div>
        <div class="case-item">
            <div class="case-image-wrapper">
                <img style="width: 100%;height: 30em;object-fit: cover;border-radius: 8px;" :src="dashuju1" alt=""></img>
            </div>
            <div class="case-content-wrapper">
                <div class="case-name">
                    {{ $t('development.name2') }}
                </div>
                <div class="case-desc">
                    {{ $t('development.text12') }}
                </div>
            </div>
        </div>
    </div>
        </div>
    </div>
</template>
<script>
import dashuju1 from '../images/dashuju1.png';
import xinghuajie from '../images/xinghuajie.png';
import VCG from '../images/VCG211377914193.jpg';
import banner from '../images/banner.jpeg';
import bg from '../images/350.jpg';
import headers from '@/components/header/headers';
import logo from '../images/nyj-logo.jpg';
import top from '../images/top.png';
export default {
    name: 'development',
    components: { headers },
    data() {
        return {
            active: '',
            dashuju1: dashuju1,
            xinghuajie: xinghuajie,
            top: top,
            list2: [{ title: 'subtitle8', content: 'text8' }, { title: 'subtitle9', content: 'text9' }, { title: 'subtitle10', content: 'text10' }],
            content: [{ title: 'subtitle5', content: 'text5' }, { title: 'subtitle6', content: 'text6' }, { title: 'subtitle7', content: 'text7' }],
            VCG: VCG,
            list: [{ title: 'subtitle', content: 'text1' }, { title: 'subtitle2', content: 'text2', text3: 'text3' }, { title: 'subtitle4', content: 'text4' }],
            banner: banner,
            bg: bg,
            active: '',
            downList: [],
            navItems: [
                { name: "遵农共享", link: logo },
                { name: 'home' },
                { name: "aboutUs" },
                { name: "products" },
                { name: "sustainableDevelopment" },
                { name: "joinUs" }
            ],
            activeNav: 'sustainableDevelopment',
        }
    },
    methods: {
        // 样式
        style(index) {
            return 'background-color: #46B135;height: 0.2em;width: 0%';
        },
        // 切换项目
        itemActive(index) {
            this.$refs.itemRef[index].style.backgroundColor = '#F4F4F4';
            this.$refs.lineRef[index].style.width = '100%';
        },
        itemout(index) {
            this.$refs.itemRef[index].style.backgroundColor = '#fff';
            this.$refs.lineRef[index].style.width = '0%';
        },

        handleCommand(item) {
            console.log(item);
            if (item.label === 'label1') {
                this.$router.push({ path: 'about', query: { active: 'label1' } });
            } else if (item.label === 'label2') {
                this.$router.push({ path: 'about', query: { active: 'label2' } });
            } else if (item.label === 'label3') {
                this.$router.push({ path: 'about', query: { active: 'label3' } });
            } else if (item.label === 'label4') {
                this.$router.push({ path: 'project', query: { active: 'label4' } });
            } else if (item.label === 'label5') {
                this.$router.push({ path: 'project', query: { active: 'label5' } });
            } else if (item.label === 'label6') {
                this.$router.push({ path: 'project', query: { active: 'label6' } });
            } else if (item.label === 'label7') {
                this.$router.push({ path: 'project', query: { active: 'label7' } });
            } else if (item.label === 'label8') {
                this.$router.push({ path: 'project', query: { active: 'label8' } });
            } else if (item.label === 'label9') {
                this.$router.push({ path: 'project', query: { active: 'label9' } });
            }else if (item.label === 'label10') {
                this.$router.push({ path: 'HomePage', query: { scroll: 'label10' } });
            }else if (item.label === 'label11') {
                this.$router.push({ path: 'HomePage', query: { scroll: 'label11' } });
            }
        },
        // 下拉菜单切换
        dropDownChange(item) {
            this.downList = [];
            if (item.name === 'aboutUs') {
                this.downList = [{ label: 'label1' }, { label: 'label2' }, { label: 'label3' }];
            } else if (item.name === 'products') {
                this.downList = [{ label: 'label4' }, { label: 'label5' }, { label: 'label6' }, { label: 'label7' }, { label: 'label8' }, { label: 'label9' }];
            } else if (item.name === 'joinUs') {
                this.downList = [{ label: 'label10' }, { label: 'label11' }];
            }
        },
        // 导航激活
        Active(item) {

            this.activeNav = item.name;
            console.log(item.name,'name');
            if (item.name === 'home') {
                this.$router.push({ path: 'HomePage' });
            } else if (item.name === 'aboutUs') {
                this.$router.push({ path: 'about', query: { active: 'label1' } });
            } else if (item.name === 'products') {
                this.$router.push({ path: 'project', query: { active: 'label4' } });
            } else if (item.name === 'joinUs') {
                this.$router.push({ path: 'joinUs' });
            }else if (item.name === 'sustainableDevelopment') {
                this.$router.push({ path: 'development', query: { active: 'development' } });
            }
        }
    },
    created() {
        console.log(this.$route.query.active);
        this.active = this.$route.query.active;
    }
}
</script>
<style scoped>
/* 案例展示区域容器 */
.case-section-container {
    width: 100%;
    max-width: 1500px;
    margin: 0 auto;
    padding: 0 1.5em;
    box-sizing: border-box;
}

/* 标题样式 */
.case-section-title {
    font-size: 2.5em;
    color: #46B135;
    text-align: center;
    margin: 3em 0;
    font-weight: 600;
    line-height: 1.3;
}

/* 单个案例项 */
.case-item {
    display: flex;
    justify-content: space-between;
    gap: 2em;
    margin-bottom: 4em;
    align-items: center;
}

/* 图片容器 */
.case-image-wrapper {
    width: 50%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease;
}

.case-image-wrapper:hover {
    transform: translateY(-5px);
}

/* 内容容器 */
.case-content-wrapper {
    width: 50%;
    padding: 1em;
}

/* 案例名称 */
.case-name {
    font-size: 1.5em;
    font-weight: 600;
    margin-bottom: 1.25em;
    color: #2d3748;
    transition: color 0.3s ease;
}

.case-item:hover .case-name {
    color: #46B135;
}

/* 案例描述 */
.case-desc {
    font-size: 1.1em;
    line-height: 1.8;
    color: #4a5568;
    text-align: justify;
}
.project-section {
    padding: 2.5em 1.5em;
    max-width: 1200px;
    margin: 0 auto;
}

/* 内容容器 */
.project-content {
    display: flex;
    flex-direction: column;
    gap: 2em;
    align-items: center;
}

/* 标题样式 */
.project-content-title {
    font-size: 1.875em;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 1em;
    position: relative;
    padding-bottom: 0.75em;
}


/* 主图样式 */
.project-main-image {
    width: 100%;
    max-width: 35em;
    aspect-ratio: 1/1;
    border-radius: 12px;
    overflow: hidden;

    transition: transform 0.3s ease;
}



.main-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease;
}

.main-img:hover {
    opacity: 0.95;
}

/* 子图画廊样式 */
.project-gallery {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 2em;
    flex-wrap: wrap;
    padding: 1em 0;
}

.gallery-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75em;
    width: 7em;
    transition: transform 0.3s ease;
}

.gallery-item:hover {
    transform: translateY(-5px);
}

/* 子图容器 */
.gallery-img-container {
    width: 100%;
    height: 15em;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background-color: #f7fafc;
}

.gallery-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.gallery-item:hover .gallery-img {
    transform: scale(1.03);
    opacity: 0.95;
}

/* 子图标题 */
.gallery-caption {
    font-size: 0.9375em;
    color: #4a5568;
    text-align: center;
    padding: 0 0.5em;
    line-height: 1.4;
    font-weight: 500;
}

/* 响应式适配 */
@media (max-width: 768px) {
    .project-section {
        padding: 1.5em 1em;
    }

    .project-content-title {
        font-size: 1.5em;
    }

    .project-main-image {
        max-width: 100%;
        height: auto;
    }

    .project-gallery {
        gap: 1.5em;
        justify-content: center;
    }

    .gallery-item {
        width: 6em;
    }

    .gallery-img-container {
        height: 12em;
    }
}

@media (max-width: 480px) {
    .project-gallery {
        gap: 1em;
    }

    .gallery-item {
        width: 5em;
    }

    .gallery-img-container {
        height: 10em;
    }

    .gallery-caption {
        font-size: 0.875em;
    }
}

.project-content-title {

    text-align: center;
    color: var(--glwColor);
    font-size: 4.2em;
    font-family: 'Courier New', Courier, monospace;

}

.dropdown-item:hover {
    color: #46B135;
    background-color: rgba(70, 177, 53, 0.1);
}

.nav-container {
    position: sticky;
    top: 0;
    width: 100%;
    box-shadow: 0 2px 4px rgba(var(--glwColorRgb), 0.1);
    padding: 0 1em;
    background: #fff;
    z-index: 999;
    box-sizing: border-box;
}

.Logo {
    display: flex;
    align-items: center;
    gap: 0.5em;
    font-weight: bold;
}

.nav-tabs {
    margin: 0 auto;
    width: 100%;
    max-width: 1500px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2em;
    cursor: pointer;
}

.nav-items-group {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2em;
    flex: 1;
}

.nav-item {
    text-align: center;
    min-width: 5em;
    font-size: 1em;
    position: relative;
    display: inline-block;
    padding: 0.8em 0;
    line-height: 1.2;
    box-sizing: border-box;
    transition: color 0.3s ease;
}

.nav-item:hover::after,
.nav-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--glwColor);
    transition: width 0.3s ease;
}

.nav-item:hover,
.nav-item.active {
    color: var(--glwColor);
}

.project {
    --glwColor: #46B135;
    --glwColorRgb: 70, 177, 53;
    font-size: 16px;
}

@media screen and (max-width: 1500px) {
    .about-page {
        font-size: 16px;
    }
}

@media screen and (max-width: 1200px) {
    .about-page {
        font-size: 14px;
    }
}

@media screen and (max-width: 768px) {
    .about-page {
        font-size: 10px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/development.vue